import { Position } from '@deck.gl/core/typed/types/layer-props';
import { Asset } from './Asset.types';
import { Option, OptionCode } from './DropdownItem.types';
import { CodeNameModel } from '.';

export type VisibleAsset = Asset & { isVisible?: boolean; index?: number };

export type MapDataElementProperties = Asset &
  Partial<{
    cluster: boolean;
    cluster_id: number;
    point_count: number;
    sumOfImpressions: number;
    sumOfAllocatedImpressionsForCluster: number;
    sumOfAvailableImpressionsForCluster: number;
    sumOfImpressionsForCluster: number;
    sumOfTotalImpressionsForCluster: number;
    minOfImpressions: number;
    maxOfImpressions: number;
    totalImpressions: number;
    impressions: number;
    availableImpressions: number;
    allocatedImpressions: number;
    size: number;
    assets: VisibleAsset[];
    isSingleLocation: boolean;
  }>;

export enum PlannerMapViewStateFields {
  longitude = 'longitude',
  latitude = 'latitude',
  zoom = 'zoom',
  maxZoom = 'maxZoom',
  pitch = 'pitch',
  bearing = 'bearing',
  width = 'width',
  height = 'height',
}

export type PlannerMapProps = {
  mapStyle?: string;
};

export const DEFAULT_MAP_STYLE = 'https://basemaps.cartocdn.com/gl/voyager-gl-style/style.json';

export interface PlannerMapDataElement<P = MapDataElementProperties> {
  id?: string;
  name?: string;
  index?: number | null;
  isVisible?: boolean;
  isEveryFrameUnavailable?: boolean;
  geometry: {
    coordinates: Position;
  };
  properties: P;
}

export interface GeoJsonData {
  type: string;
  properties: {
    radius: number;
  };
  geometry: { type: string; coordinates: Position };
}

export interface Visibility {
  include: boolean;
  radius: number;
}

export type PlannerPoi = PlannerMapDataElement<{
  categoryName: string;
  categoryType: string;
  address: string;
  postalCode: string;
  dataProvider: string;
  mediaOwner: string;
  type: string;
  visibility: Visibility;
  isOpenStreetMapPoi?: boolean;
}> & {
  name: string;
  id: string;
};

export interface PoiSubOptionResponse {
  categoryName: string;
  suboptions?: PoiSubOptionResponse[];
}

export interface PoiOptionResponse {
  categoryType: string;
  suboptions: PoiSubOptionResponse[];
}

export interface PoiOptionListResponse {
  dataProvider: string;
  options: PoiOptionResponse[];
}

export type PoiOption = Omit<Option, 'code' | 'children'> & {
  code: string;
  categoryName?: string;
  categoryType?: string;
  categoryPath?: string;
  children?: PoiOption[];
  include?: boolean;
  radius?: number;
  latitude?: number;
  longitude?: number;
};

export type DataProviderName = string;
export type DataProvidersWithPoiOptions = {
  [key: DataProviderName]: PoiOption[];
};

export interface POI extends CodeNameModel {
  include: boolean;
  radius: number;
  dataProvider: string;
  hasChildren: boolean;
  rootCategoryType: OptionCode;
  parentCategory: string;
  categoryPath: string;
  tooltip: string;
  poiPoints?: PlannerPoi[];
}
